import { ReportState } from "./Enums";
import {Naics} from './naics';
import {User} from './user';

export class AdminReport {
}


export class AdminReportMinimal {
    ID: number;
    REPORT_ID: string;
    REPORT_NAME: string;
    CREATED_BY: string;
    REPORT_VERSION_ID: string;
    VALUATION_DATE: string;
    FINAL_VALUE: number;
    REFERENCE: string;
    COMPLETION: number;
    DBA: string;
    COMPANY_NAME: string;
    STATE: ReportState;
    UNLOCKED_AT: string;
    UNLOCKED_EXP: string;
    LAST_UPDATED_ON: string;
    GENERATOR_NAME: User;
    GENERATOR_EMAIL: string;
    NAICS: Naics;
    NOTES_COUNT: number;
    ORGANIZATION: string;

    static parse(json: any): AdminReportMinimal {
        if (json) {
            const a = new AdminReportMinimal();

            a.ID = json.ID;
            a.REPORT_ID = json.REPORT_ID;
            a.REPORT_NAME = json.REPORT_NAME;
            a.CREATED_BY = json.CREATED_BY;
            a.REPORT_VERSION_ID = json.REPORT_VERSION_ID;
            a.VALUATION_DATE = json.VALUATION_DATE;
            a.FINAL_VALUE = json.FINAL_VALUE;
            a.REFERENCE = json.REFERENCE;
            a.COMPLETION = json.COMPLETION;
            a.DBA = json.DBA;
            a.COMPANY_NAME = json.COMPANY_NAME;

            a.STATE = ReportState[<string>json.STATE];

            a.UNLOCKED_AT = json.UNLOCKED_AT;
            a.UNLOCKED_EXP = json.UNLOCKED_EXP;
            a.LAST_UPDATED_ON = json.LAST_UPDATED_ON;
            if (json.NAICS)
              a.GENERATOR_NAME = User.parse(json.GENERATOR_NAME);
            a.GENERATOR_EMAIL = json.GENERATOR_EMAIL;
            if (json.NAICS)
              a.NAICS = Naics.parse(json.NAICS);
            a.NOTES_COUNT = json.NOTES_COUNT;
            a.ORGANIZATION = json.ORGANIZATION;

            return a;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<AdminReportMinimal> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(AdminReportMinimal.parse(j));

        return arr;
    }

}
